import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "../features/API/apiSlice";
import projectReducer from "../features/projects/projectSlice";
import searchReducer from "../features/Search/searchSlice";
import taskReducer from "../features/tasks/taskSlice";
import teamMemberReducer from "../features/teamMembers/teamMembersSlice";

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    project: projectReducer,
    teamMember: teamMemberReducer,
    task: taskReducer,
    search: searchReducer,
  },
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getdefaultMiddlewares) =>
    getdefaultMiddlewares().concat(apiSlice.middleware),
});
